<script setup lang="ts">
import styles from '@/assets/sass/components/article-item.module.scss';
import SkeletonBox from '@/components/SkeletonBox.vue';
</script>
<template>
    <article :class="styles['article-item']">
        <div :class="styles['image-container']">
            <SkeletonBox :class="styles.image" :height="null" :width="null" />
        </div>
        <div :class="styles.text">
            <h2 :class="styles.heading">
                <SkeletonBox />
            </h2>
            <div :class="styles.date">
                <SkeletonBox width="40%" />
            </div>
            <div :class="styles.summary">
                <SkeletonBox />
                <SkeletonBox width="80%" />
            </div>
        </div>
    </article>
</template>
